import { postWpAjax } from '../../common/ApiClient';

export const saveOnboardingFinished = async (userId: number | null): Promise<any> => {
  const data = new FormData();
  data.append('userId', userId?.toString() || '');

  return await postWpAjax<any>('save_onboarding_finished', data);
};
